import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HxPagedListDirective } from 'hx-components';
import { BrandModel, HxBrandService, PagedList } from 'hx-services';
import { firstValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzThAddOnComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { DatePipe, NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-brand-list',
    templateUrl: './brand-list.component.html',
    styleUrls: ['./brand-list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzThAddOnComponent, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, DatePipe, TranslocoPipe]
})
export class BrandsListComponent extends HxPagedListDirective<BrandModel> implements OnInit {
  isEdit = false;
  query = '';

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    protected brandService: HxBrandService,
    protected notification: NzNotificationService,
    protected tr: TranslocoService,
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        const asNumberFn = (name: string, def?: number) => paramMap.get(name) ? Number(paramMap.get(name)) : def;
        // const asBooleanFn = (name: string, def?: boolean) => paramMap.get(name) ? paramMap.get(name) === 'true' : def;
        super.load(paramMap);
      });
  }

  async remove(id: number): Promise<void> {
    await this.brandService.removeBrand(id);
    this.loadData();
    this.notification.success(this.tr.translate('nav.Brands'), this.tr.translate('nt.dataRemoved'));
  }

  protected loadList(): Promise<PagedList<BrandModel>> {
    return this.brandService.getBrands({
      limit: this.limit,
      page: this.page,
      query: this.query
    }) as unknown as Promise<PagedList<BrandModel>>;
  }
}
